import { render, staticRenderFns } from "./Events.html?vue&type=template&id=0c61e81e&scoped=true&external"
import script from "./Events.js?vue&type=script&lang=js&external"
export * from "./Events.js?vue&type=script&lang=js&external"
import style0 from "./Events.scss?vue&type=style&index=0&id=0c61e81e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c61e81e",
  null
  
)

export default component.exports